// Validation utilities
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const validateEmail = (email) => {
  if (!email.trim()) {
    return "Email is required.";
  }
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  return "";
};

export const validatePassword = (password) => {
  if (!password.trim()) {
    return "Password is required.";
  }
  if (!passwordRegex.test(password)) {
    return "Password must be at least 8 characters with uppercase, lowercase, number, and symbol.";
  }
  return "";
};

export const validateRequired = (value, fieldName) => {
  if (!value.trim()) {
    return `${fieldName} is required.`;
  }
  return "";
};

export const validateForm = (formData, validationRules) => {
  const errors = {};

  Object.keys(validationRules).forEach((field) => {
    const rule = validationRules[field];
    const value = formData[field];

    if (rule.required) {
      const error = validateRequired(value, rule.label || field);
      if (error) {
        errors[field] = error;
        return;
      }
    }

    if (rule.type === "email" && value) {
      const error = validateEmail(value);
      if (error) {
        errors[field] = error;
      }
    }

    if (rule.type === "password" && value) {
      const error = validatePassword(value);
      if (error) {
        errors[field] = error;
      }
    }
  });

  return errors;
};
